import React, { useEffect, useState } from "react";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import { useNavigate } from "react-router-dom";
import { useDateUtils } from "../../../utils/formatTime";
import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import MainCard from "../../../components/Maincard";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HeadingCard from "../../newComponent/NewCardsComp/HeadingCard";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import SearchButton from "../../newComponent/NewButtonComp/SearchButton";
import StyledTableContainer from "../../newComponent/TableContainer";
import CustomPopup from "../../../components/CustomPopup";
import TaskDetails from "./TaskDetails";

import MoreTaskDetails from "./BranchVisitDetails";
import { useGetTokenOrLogout } from "../../../utils/token";
import LoaderComp from "../../newComponent/LoaderComp/Loader";
import LeadAssignConverted from "./LeadAssignConverted";
import DemoDetails from "./DemoDetails";
import BranchVisitDetails from "./BranchVisitDetails";
import EnrollDetails from "../../../pages/AllUserDashboards/popupComponent/EnrollDetails";
import MoreCardDetails from "../../../pages/AllUserDashboards/popupComponent/MoreCardDetails";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function AdvisorTaskWiseReport() {
  const userRole = localStorage.getItem("userRole");
  const userId = localStorage.getItem("userId");
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();
  const [monthList, setMonthList] = useState([]);
  const [monthname, setMonthName] = useState(null);
  const [selectedYear, setSelectedYear] = useState({
    year: new Date().getFullYear(),
  });
  const [branchList, setBranchList] = useState([]);
  const [advisorList, setAdvisorList] = useState([]);
  const [status, setSatus] = useState([
 
  ]);
  const [selectedStatus, setSelectedStatus] = useState([1, 0]);

  const [advisorName, setAdvisorName] = useState([{ user_id: "all" }]);
  const [branchName, setBranchName] = useState([

  ]);
  const [allAdvisorList, setAllAdvisorList] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState(["all"]);
  const [revenueData, setRevenueData] = useState([]);
  const { currentMonthName } = useDateUtils();
  const [loading, setLoading] = useState(false);
  const [currentMonthIndex, setCurrentMonthIndex] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
  const [TypeOfTaskData, setTypeOfTaskData] = useState([]);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [openDetailPopup, setopenDetailpopup] = useState(false);
  const [taskName, setTaskName] = useState(null);
  const [taskKey, setTaskKey] = useState(null);

  const [statusList, setStatusList] = useState([
    { id: 1, name: "Active" },
    { id: 0, name: "Inactive" },
  ]);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}month`);
        if (response.ok) {
          const data = await response.json();

          setMonthList(data);
          const currentIndex = data.findIndex(
            (month) => month.month_full_name === currentMonthName
          );

          setCurrentMonthIndex(currentIndex !== -1 ? currentIndex : 0);
          setMonthName(data[currentIndex].month_full_name);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const handleNextMonth = () => {
    if (currentMonthIndex < monthList.length - 1) {
      const nextIndex = currentMonthIndex + 1;
      setCurrentMonthIndex(nextIndex);
      const monthName = monthList[nextIndex].month_full_name;
      setMonthName(monthName);
      handleSearchData(monthName);
    }
  };

  const handlePreviousMonth = () => {
    if (currentMonthIndex > 0) {
      const prevIndex = currentMonthIndex - 1;
      setCurrentMonthIndex(prevIndex);
      const monthName = monthList[prevIndex].month_full_name;
      setMonthName(monthName);
      handleSearchData(monthName);
    }
  };

  const years = Array.from({ length: 5 }, (_, index) => ({
    year: new Date().getFullYear() - 3 + index,
  }));

  const handleselectedYear = async (value) => {
    setSelectedYear(value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch`);
        if (response.ok) {
          const data = await response.json();
          setBranchList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  // const [allBranchList, setAllBranchlist] = useState([
  //   { id: "all", branch_name: "Select All" },
  //   ...(branchList || []),
  // ]);

  let allBranchList = [{branch_name :"Select All"} ,...branchList]
  // useEffect(() => {
  //   if (Array.isArray(branchList)) {
  //     setAllBranchlist([
  //       { id: "all", branch_name: "Select All" },
  //       ...branchList,
  //     ]);
  //   }
  // }, [branchList]);

  const handleBranchChange = (event, value) => {
    if (value.some((item) => item.branch_name === "Select All")) {
    const selectedIds =branchList.map((i) => i.id)
      setBranchName(branchList);
      setSelectedBranchId(selectedIds);
    } else {
      // If individual branches are selected, remove "Select All"
      setBranchName(value);
      setSelectedBranchId(value.map((i) => i.id));
    }
  };

  const allStatusList = [{ id: 2, name: "Both" }, ...statusList];
  const handleStatusChange = (e, value) => {
    if (value.some((item) => item.id === 2)) {
      const selectedIds = statusList.map((i) => i.id);
      setSatus(statusList);
      setSelectedStatus(selectedIds);
    } else {
      const selectedIds = value.map((i) => i.id);
      setSatus(value);
      setSelectedStatus(selectedIds);
    }
  };

  const handleSearchAdvisors = async (selectedStatus) => {
    const requestData = {
      status: selectedStatus,
         branch_id: selectedBranchId,
    };

    try {
      const response = await fetch(`${API_ENDPOINT}advisor/bystutus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const result = await response.json();
        // const reversedData = result.slice().reverse();
        setAdvisorList(result);
      } else {
        console.log("Server Error", "error");
        setAdvisorList([]);
      }
    } catch (error) {
      console.log("Server Error", "error");
      setAdvisorList([]);
    }
  };

  useEffect(() => {
    handleSearchAdvisors(selectedStatus);
  }, [selectedStatus,selectedBranchId]);

  useEffect(() => {
    const updatedList = [
      ...(advisorList.length > 1
        ? [
            {
              first_name:
                advisorName.length === advisorList.length
                  ? "Deselect All"
                  : "Select All",
            },
          ]
        : []),
      ...advisorList,
    ];
    setAllAdvisorList(updatedList);
  }, [advisorList, advisorName]);

  const handleUserChange = (event, value) => {
    if (value.some((item) => item.first_name === "Select All")) {
      // If "Select All" is selected, set all branches
      setAdvisorName(advisorList);
    } else if (value.some((option) => option.first_name === "Deselect All")) {
      setAdvisorName([]);
    } else {
      // If individual branches are selected, remove "Select All"
      setAdvisorName(value);
    }
  };

  // Select Advisor Automatic base on Branch
  useEffect(() => {
    if (!Array.isArray(advisorList)) {
      console.error("advisorList is not an array:", advisorList);
      return;
    }

    if (selectedBranchId.includes("all")) {
      setAdvisorName(advisorList);
    } else {
      const branchViseAdvisor = advisorList.filter((advisor) =>
        selectedBranchId.includes(advisor.branch_id)
      );
      setAdvisorName(branchViseAdvisor);
    }
  }, [selectedBranchId, advisorList]);

  const selectedAdvisor = advisorName.map((i) => i.user_id);

  const handleSearchData = async (month) => {
    setLoading(true);

    const requestData = {
      user_id: parseInt(userId),
      year: selectedYear?.year,
      report_for:
        userRole === "center_admin" && selectedAdvisor.includes("all")
          ? "all"
          : userRole === "center_admin" && !selectedAdvisor.includes("all")
          ? selectedAdvisor
          : null,
      month: month,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}advisor-rev-target/advisor-report`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

  const result = await response.json();
      if (response.ok) {
      

        const data = result?.data;

        setRevenueData(Object.entries(data));
        setLoading(false);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        showSnackbar("Please select user", "error");
        setRevenueData([]);
        setLoading(false);
      } else if (result.status === 440) {
        navigate("/page440");
      } else if (response.status === 400) {
        showSnackbar(response.message, "error");
        setRevenueData([]);
        setLoading(false);
      }  
      
      else {
        navigate("/page500");
      }
    } catch (error) {
      navigate("/page500");
    }
  };

  const labelMap = {
    TotalTask: "Total Task",
    CallsConnected: "Calls Connected",
    CallsMade: "Calls Made",
    VirtualAppointment: "Virtual Appointment",
    BranchVisit: "Branch Visit",
    RevenueCollected: "Revenue Collected",
    DemoCompleted: "Demo Completed",
    Enrollment: "Enrollment",
    LeadAssigned: "Lead Assigned",
    LeadConverted: "Lead Converted",
  };

  useEffect(() => {
    handleSearchData(currentMonthName);
  }, []);

  const handleView = () => {
    const url = `/view-task-wise-report-pdf`;
    window.open(url, "_blank");
    const targetDataObject = {
      revenueData,
      advisorName,
      selectedYear,
      monthname,
    };
    localStorage.setItem("targetdata", JSON.stringify(targetDataObject));
  };


  // Hyperlink popup
  const handleOpenDetailPopup = (headerName, Taskkey) => {
    setopenDetailpopup(true);
    setTaskName(headerName);
    setTaskKey(Taskkey);
  };

  const handleCloseDetailPopup = () => {
    setopenDetailpopup(false);
  };

  // hyperlink detail data
  const getTaskMoreDetails = async (headerName, Taskkey) => {
    setDetailsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const requestData = {
      user_id: parseInt(userId),
      year: selectedYear?.year,
      report_for: advisorName.length>0 ?  advisorName.map((i) => i.user_id) :"all",

      filter_type: Taskkey,
      month: monthname,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}advisor-rev-target/advisor-report-with-detail`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

        const result = await response.json();
      if (response.ok) {
      

        setTypeOfTaskData(result);
        setDetailsLoading(false);
        handleOpenDetailPopup(headerName, Taskkey);
      }else if (response.status===400) {
         showSnackbar(result.message, "error");
        setDetailsLoading(false);
      }
       else {
        console.log("Error");
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch (error) {
      console.log(error, "Error");
      showSnackbar("Server Error", "error");
      setDetailsLoading(false);
    }
  };

  return (
    <>
      <LoaderComp isLoading={detailsLoading} />
      <Backdrop open={loading} style={{ zIndex: 9999 }}>
        <Stack direction="row" spacing={1}>
          <Typography
            variant="h4"
            color="secondary"
            fontWeight={800}
            marginRight={2}
          >
            Fetching
          </Typography>
          <CircularProgress color="primary" />
        </Stack>
      </Backdrop>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={5} md={4} lg={2}>
          <HeadingCard label="Task Wise Report" />
        </Grid>
        {userRole === "center_admin" && (
          <Grid item xs={12} sm={7} md={8} lg={10} textAlign="end">
            <Button
              color="secondary"
              size="small"
              variant="contained"
              style={{ borderRadius: "25px" }}
              startIcon={<DownloadIcon />}
              onClick={handleView}
            >
              Download Report
            </Button>
          </Grid>
        )}

        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              {userRole === "center_admin" && (
                <>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="h6">Select Branch</Typography>
                    <CustomAutocompleteComp
                      size="small"
                      value={branchName}
                      multiple
                      onChange={handleBranchChange}
                      options={allBranchList}
                      getOptionLabel={(option) => option.branch_name
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            style: { borderRadius: "14px" }, // Add borderRadius here
                          }}
                          size="small"
                        />
                      )}
                      tooltipContent={(option) => option.branch_name}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      renderOption={(props, option, { selected }) => (
                        <li
                          {...props}
                          style={{
                            backgroundColor: selected ? "#e0f7fa" : "inherit",
                          }}
                        >
                          {option.branch_name}
                        </li>
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="h6">Select Advisor Status</Typography>

                    <CustomAutocompleteComp
                      multiple
                      value={status}
                      onChange={handleStatusChange}
                      size="small"
                      options={allStatusList}
                      getOptionLabel={(option) => option.name}
                      tooltipContent={(option) => option.name}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="h6">Select Advisor</Typography>
                    <CustomAutocompleteComp
                      size="small"
                      value={advisorName}
                      multiple
                      onChange={handleUserChange}
                      options={allAdvisorList}
                      getOptionLabel={(option) =>
                        `${option.first_name ? option.first_name : ""} ${
                          option.last_name ? option.last_name : ""
                        }`
                      }
                       noOptionsText={
                        branchName.length === 0 ? "Select Branch First" :
                        status.length > 0
                          ? allAdvisorList.length === 0
                            ? "No Advisor Available"
                            : ""
                          : "Please Select Advisor Status"
                      }
                      tooltipContent={(option) =>
                        `${option.first_name ? option.first_name : ""} ${
                          option.last_name ? option.last_name : ""
                        }`
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            style: { borderRadius: "14px" }, // Add borderRadius here
                          }}
                        />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.user_id === value.user_id
                      }
                      renderOption={(props, option, { selected }) => {
                        return (
                          <li
                            {...props}
                            style={{
                              backgroundColor: selected ? "#e0f7fa" : "inherit",
                            }}
                          >
                            {option.first_name} {option.last_name}
                          </li>
                        );
                      }}
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="h6">Select Year</Typography>
                <CustomAutocompleteComp
                  value={selectedYear}
                  onChange={(event, value) => handleselectedYear(value)}
                  size="small"
                  options={years}
                  getOptionLabel={(option) => option.year}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={userRole === "advisor" ? 3 : 12}
                textAlign="end"
              >
                <Typography sx={{ visibility: "hidden" }}>
                  Spacing purpose
                </Typography>
                <SearchButton
                  size="small"
                  onClick={() => handleSearchData(monthname)}
                  showIcon={true}
                >
                  Search
                </SearchButton>
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Stack
                  display="flex"
                  flexDirection="row"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Typography
                    style={{
                      cursor: "pointer",
                      display: "inline-flex", // Align content inside
                      justifyContent: "center",
                      alignItems: "center",
                      width: "25px", // Set width and height for circle
                      height: "25px",
                      borderRadius: "50%", // Makes the element circular
                      backgroundColor: "#00C853", // Optional: add background color
                      border: "1px solid #ccc", // Optional: add border

                      opacity: currentMonthIndex === 0 ? 0.5 : 1,
                    }}
                    onClick={handlePreviousMonth}
                  >
                    <ArrowBackIcon
                      style={{ color: "white", fontSize: "1rem" }}
                    />
                  </Typography>

                  <Typography variant="h4">
                    {monthname} {selectedYear?.year}
                  </Typography>
                  <Typography
                    style={{
                      cursor: "pointer",
                      display: "inline-flex", // Align content inside
                      justifyContent: "center",
                      alignItems: "center",
                      width: "25px", // Set width and height for circle
                      height: "25px",
                      borderRadius: "50%", // Makes the element circular
                      backgroundColor: "#00C853", // Optional: add background color
                      border: "1px solid #ccc", // Optional: add border
                      opacity:
                        currentMonthIndex === monthList.length - 1 ? 0.5 : 1,
                    }}
                    onClick={handleNextMonth}
                  >
                    <ArrowForwardIcon
                      style={{ color: "white", fontSize: "1rem" }}
                    />
                  </Typography>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <StyledTableContainer component={Paper} borderLeft={true}>
                  <Table
                    sx={{ minWidth: 650, tableLayout: "fixed" }}
                    aria-label="simple table"
                    stickyHeader
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ borderLeft: "0.1px solid #C3C3C3" }}>
                          Task Category
                        </TableCell>
                        <TableCell>Measure</TableCell>
                      </TableRow>
                    </TableHead>

                    {revenueData.map(([key, value], index) => (
                      <TableBody>
                        <TableRow
                          key={key}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "#f0f0f0" : "inherit",
                          }}
                        >
                          <TableCell sx={{ borderLeft: "0.1px solid #C3C3C3" }}>
                            {labelMap[key] || key}
                          </TableCell>
                          <TableCell
                            style={{ color: "blue", cursor: "pointer" }}
                            onClick={() =>
                              getTaskMoreDetails(labelMap[key] || key, key)
                            }
                          >
                            {value}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ))}
                  </Table>
                </StyledTableContainer>
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={openDetailPopup}
        onClose={handleCloseDetailPopup}
        title={`${taskName}  Details`}
        component={
          taskKey === "RevenueCollected" ? (
            <MoreCardDetails
              onClose={handleCloseDetailPopup}
              selectedYear={selectedYear?.year}
              monthName={monthname}
              SelectedCardData={TypeOfTaskData}
              selectedFilter="default"
          
              // selectedCardName={selectedCardName}
              // selectedCountFilter={selectedcardFilter}
            />
          ) : taskKey === "Enrollment" ? (
            <EnrollDetails
              onClose={handleCloseDetailPopup}
              selectedFilter="default"
              SelectedCardData={TypeOfTaskData}
              selectedYear={selectedYear?.year}
              monthName={monthname}
            />
          ) : taskKey === "BranchVisit" 
           
           ? (
            <BranchVisitDetails
              onClose={handleCloseDetailPopup}
              selectedYear={selectedYear?.year}
              monthName={monthname}
              SelectedData={TypeOfTaskData}
              selectedFilter="default"

              // selectedCardName={selectedCardName}
              // selectedCountFilter={selectedcardFilter}
            />
          ) :    taskKey === "LeadAssigned" ||
            taskKey === "LeadConverted" ? (
              <LeadAssignConverted
              onClose={handleCloseDetailPopup}
              selectedYear={selectedYear?.year}
              monthName={monthname}
              SelectedData={TypeOfTaskData}
              selectedFilter="default"

              // selectedCardName={selectedCardName}
              // selectedCountFilter={selectedcardFilter}
            />
            ) : 
            taskKey === "DemoCompleted"  ? (
              <DemoDetails
              onClose={handleCloseDetailPopup}
              selectedYear={selectedYear?.year}
              monthName={monthname}
              SelectedData={TypeOfTaskData}
              selectedFilter="default"

              
            />
            )
:
          (
            <TaskDetails
              onClose={handleCloseDetailPopup}
              selectedYear={selectedYear?.year}
              monthName={monthname}
              SelectedData={TypeOfTaskData}
              selectedFilter="default"

              // selectedCardName={selectedCardName}
              // selectedCountFilter={selectedcardFilter}
            />
          )
        }
        maxWidth="lg"
        showDivider={true}
      />
    </>
  );
}
